'use client';

import React, { useCallback } from 'react';
import { InvisibleSmartCaptcha } from '@yandex/smart-captcha';

import useAppSelector from 'hooks/redux/useAppSelector';

import { YANDEX_CAPTCHA_KEY } from 'config';
import { YandexCaptchaError } from 'constants/captcha/yandex';

import { YandexCaptchaStatus } from 'types/captcha';
import { IYandexCaptchaProps } from './YandexCaptcha.types';

const YandexCaptcha = ({
  visible,
  onChange,
  onSuccess,
  onChangeStatus,
  onChangeVisible,
  ...props
}: IYandexCaptchaProps) => {
  const { language } = useAppSelector(state => state.language);

  const onCaptchaSuccess = useCallback(
    token => {
      onChange(token);
      onSuccess(token);
      onChangeStatus(YandexCaptchaStatus.SUCCESS);
    },
    [onChangeStatus, onChange, onSuccess],
  );

  const onTokenExpired = useCallback(() => {
    onChange(null);
    onChangeVisible(false);
    onChangeStatus(YandexCaptchaStatus.NOT_VALIDATED);
  }, [onChangeStatus, onChangeVisible, onChange]);

  const onCaptchaError = useCallback(
    (errorName: string) => () => {
      onChangeStatus(YandexCaptchaStatus.ERROR, errorName);
      onChangeVisible(false);

      console.error('Yandex Captha', 'Yandex Captha Error', { errorName });
    },
    [onChangeStatus, onChangeVisible],
  );

  return (
    <InvisibleSmartCaptcha
      visible={visible}
      language={language}
      sitekey={YANDEX_CAPTCHA_KEY}
      onSuccess={onCaptchaSuccess}
      onTokenExpired={onTokenExpired}
      onChallengeHidden={() => onChangeVisible(false)}
      onNetworkError={onCaptchaError(YandexCaptchaError.NETWORK_ERROR)}
      onJavascriptError={onCaptchaError(YandexCaptchaError.JAVASCRIPT_ERROR)}
      {...props}
    />
  );
};

export default YandexCaptcha;
